import {Sparkles} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
}

function EmptyState({ icon: Icon = Sparkles, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center rounded-[28px] border-4 border-dashed border-[#FFDE00]/30 bg-white/[0.03] px-4 py-7 text-center sm:px-6 sm:py-12">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#3B4CCA] shadow-[0_4px_0_#24308a]">
        <Icon className="h-6 w-6 text-[#FFDE00]" />
      </div>
      <h3 className="font-display text-2xl font-extrabold text-white">{title}</h3>
      {description ? <p className="mt-2 max-w-sm text-sm font-semibold text-white/55">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  )
}

export default EmptyState
